// Restaurants & Pizzerias guide for Bellagio - trilingual
export const RESTAURANTS = [
  {
    id: "alle-darsene-di-loppia",
    name: "Alle Darsene di Loppia",
    icon: "🍽️",
    closed: { it: "Lunedì", en: "Monday", fr: "Lundi" },
    note: {
      it: "Prenotazioni esclusivamente online tramite il loro sito.",
      en: "Reservations accepted exclusively online via their website.",
      fr: "Réservations uniquement en ligne via leur site web.",
    },
    desc: {
      it: "Vicino ai giardini di Villa Melzi, propone cucina raffinata con focus su prodotti locali e di stagione. Aperto solo a pranzo, perfetto per chi cerca un'esperienza gourmet e tranquilla.",
      en: "Near Villa Melzi gardens, refined cuisine focused on local and seasonal produce. Open for lunch only, perfect for a tranquil gourmet experience.",
      fr: "Près des jardins de Villa Melzi, cuisine raffinée axée sur les produits locaux et de saison. Ouvert uniquement le midi.",
    },
  },
  {
    id: "ittiturismo-mella",
    name: "Ittiturismo Mella",
    icon: "🐟",
    closed: { it: "Mercoledì", en: "Wednesday", fr: "Mercredi" },
    desc: {
      it: "A pochi passi dal lago, propone pesce di lago fresco pescato ogni giorno, in un ambiente informale e amichevole, ideale per un pranzo genuino.",
      en: "A few steps from the lake, daily-caught fresh lake fish in a friendly informal setting, perfect for an honest lunch.",
      fr: "À deux pas du lac, poissons frais du lac pêchés chaque jour, ambiance conviviale et informelle.",
    },
  },
  {
    id: "gioya-arturo",
    name: "Ristorante Gioya & Bistrò Arturo (Hotel Du Lac)",
    icon: "🌅",
    closed: { it: "Gioya: Domenica, Lunedì, Martedì", en: "Gioya: Sunday, Monday, Tuesday", fr: "Gioya : Dimanche, Lundi, Mardi" },
    note: {
      it: "Consigliata la terrazza panoramica sul lago.",
      en: "Rooftop terrace with panoramic lake views highly recommended.",
      fr: "Terrasse panoramique avec vue sur le lac vivement conseillée.",
    },
    desc: {
      it: "All'interno dell'Hotel Du Lac, due locali complementari con terrazza sul lago. Gioya offre cucina gourmet raffinata, ideale per una cena romantica; Bistrò Arturo propone piatti italiani e mediterranei in un'atmosfera più informale.",
      en: "Inside Hotel Du Lac, two complementary venues with a rooftop on the lake. Gioya offers refined gourmet cuisine — perfect for a romantic dinner; Bistrò Arturo serves Italian and Mediterranean dishes in a more informal setting.",
      fr: "Dans l'Hôtel Du Lac, deux lieux complémentaires avec rooftop sur le lac. Gioya pour une cuisine gastronomique raffinée; Bistrò Arturo plus décontracté.",
    },
  },
  {
    id: "la-dolce-vita",
    name: "La Dolce Vita",
    icon: "🍷",
    closed: { it: "Giovedì", en: "Thursday", fr: "Jeudi" },
    desc: {
      it: "Nelle viuzze del borgo, ristorante elegante con cucina italiana raffinata, perfetto per una serata romantica curata in ogni dettaglio.",
      en: "In the village alleys, an elegant restaurant serving refined Italian cuisine — perfect for a carefully curated romantic atmosphere.",
      fr: "Dans les ruelles du bourg, restaurant élégant à la cuisine italienne raffinée, parfait pour une soirée romantique.",
    },
  },
  {
    id: "albori",
    name: "Albòri",
    icon: "🌊",
    closed: { it: "Sempre aperto", en: "Always open", fr: "Toujours ouvert" },
    desc: {
      it: "All'interno del Belvedere Hotel, offre viste spettacolari sul Lago di Como e piatti italiani tradizionali con servizio attento e raffinato. Ideale per una cena con vista.",
      en: "Inside Belvedere Hotel, spectacular Lake Como views and traditional Italian dishes with refined service. Ideal for a dinner with a view.",
      fr: "Dans le Belvedere Hotel, vues spectaculaires sur le lac et plats italiens traditionnels avec un service soigné.",
    },
  },
  {
    id: "bilacus",
    name: "Ristorante Bilacus",
    icon: "🍽️",
    closed: { it: "Lunedì", en: "Monday", fr: "Lundi" },
    desc: {
      it: "Sulla famosa Salita Serbelloni, locale accogliente che unisce piatti tradizionali a un tocco moderno. Ambiente caldo e curato, perfetto per una cena raffinata in uno dei vicoli più caratteristici del borgo.",
      en: "On the famous Salita Serbelloni, cosy restaurant blending traditional dishes with a modern touch. Warm setting, perfect for a refined dinner in one of the village's most characteristic alleys.",
      fr: "Sur la célèbre Salita Serbelloni, lieu chaleureux qui marie tradition et modernité. Idéal pour un dîner raffiné.",
    },
  },
  {
    id: "mistral",
    name: "Ristorante Mistral",
    icon: "⭐",
    closed: { it: "Lunedì e Martedì", en: "Monday and Tuesday", fr: "Lundi et Mardi" },
    note: {
      it: "Cucina d'autore e tecniche molecolari. Consigliata la prenotazione e un abbigliamento curato.",
      en: "Signature cuisine and molecular techniques. Reservation and smart dress recommended.",
      fr: "Cuisine d'auteur et techniques moléculaires. Réservation et tenue soignée recommandées.",
    },
    desc: {
      it: "Il fiore all'occhiello del Grand Hotel Villa Serbelloni: ristorante gastronomico già premiato con stella Michelin, celebre per la cucina creativa e le tecniche d'avanguardia — come il gelato mantecato all'azoto liquido. Sala elegante e terrazza con vista sul lago: l'indirizzo per una cena d'alta cucina in un'occasione davvero speciale, un gradino sopra per classe ed esperienza.",
      en: "The flagship of Grand Hotel Villa Serbelloni: a fine-dining restaurant, formerly Michelin-starred, renowned for its creative, avant-garde cuisine — such as liquid-nitrogen churned ice cream. Elegant dining room and lake-view terrace: the address for haute cuisine on a truly special occasion, a notch above in class and experience.",
      fr: "Le fleuron du Grand Hotel Villa Serbelloni : restaurant gastronomique anciennement étoilé Michelin, réputé pour sa cuisine créative et ses techniques d'avant-garde — comme la glace prise à l'azote liquide. Salle élégante et terrasse avec vue sur le lac : l'adresse pour une haute cuisine lors d'une occasion vraiment spéciale, un cran au-dessus en classe et en expérience.",
    },
  },
  {
    id: "la-goletta",
    name: "Ristorante La Goletta (Grand Hotel Villa Serbelloni)",
    icon: "🍴",
    closed: { it: "Sempre aperto", en: "Always open", fr: "Toujours ouvert" },
    note: {
      it: "Aperto con orario continuato per pranzo e cena. Splendida terrazza fronte lago e area bordo piscina.",
      en: "Open all day for lunch and dinner. Beautiful lakefront terrace and poolside area.",
      fr: "Ouvert en continu pour le déjeuner et le dîner. Superbe terrasse face au lac et espace au bord de la piscine.",
    },
    desc: {
      it: "All'interno del Grand Hotel Villa Serbelloni, propone cucina mediterranea e specialità italiane in un ambiente elegante ma informale. La splendida terrazza fronte lago e l'area bordo piscina la rendono ideale per un pranzo rilassante o una cena al tramonto con vista sul Lago di Como.",
      en: "Inside the Grand Hotel Villa Serbelloni, Mediterranean cuisine and Italian specialities in an elegant yet informal setting. Its beautiful lakefront terrace and poolside area make it ideal for a relaxed lunch or a sunset dinner overlooking Lake Como.",
      fr: "Au sein du Grand Hotel Villa Serbelloni, cuisine méditerranéenne et spécialités italiennes dans un cadre élégant mais informel. Sa superbe terrasse face au lac et son espace au bord de la piscine en font un lieu idéal pour un déjeuner détendu ou un dîner au coucher du soleil avec vue sur le lac de Côme.",
    },
  },
  {
    id: "aperitivo-et-al",
    name: "Aperitivo et Al",
    icon: "🍷",
    closed: { it: "Sempre aperto", en: "Always open", fr: "Toujours ouvert" },
    note: { it: "Non si accettano prenotazioni.", en: "Reservations not accepted.", fr: "Pas de réservations." },
    desc: {
      it: "Sulla famosa Salita Serbelloni, perfetto per un aperitivo o un pasto leggero, con un'ampia selezione di vini e formaggi in un'atmosfera rilassata.",
      en: "On Salita Serbelloni, perfect for an aperitivo or light meal — wide selection of wines and cheeses, relaxed atmosphere.",
      fr: "Sur la Salita Serbelloni, parfait pour l'apéritif ou un repas léger, large sélection de vins et fromages.",
    },
  },
  {
    id: "san-giacomo",
    name: "Trattoria San Giacomo",
    icon: "🏡",
    closed: { it: "Martedì", en: "Tuesday", fr: "Mardi" },
    note: { it: "Non si accettano prenotazioni.", en: "Reservations not accepted.", fr: "Pas de réservations." },
    desc: {
      it: "Sulla Salita Serbelloni, trattoria tradizionale con piatti tipici lombardi in un ambiente rustico e accogliente. Per chi desidera un pasto autentico immerso nella storia del borgo.",
      en: "On Salita Serbelloni, traditional trattoria serving typical Lombard dishes in a rustic, welcoming setting. For those wanting an authentic meal in the historic village.",
      fr: "Sur la Salita Serbelloni, trattoria traditionnelle aux plats lombards typiques, cadre rustique et chaleureux.",
    },
  },
  {
    id: "salice-blu",
    name: "Salice Blu",
    icon: "🎨",
    closed: { it: "Martedì", en: "Tuesday", fr: "Mardi" },
    desc: {
      it: "Cucina creativa con grande attenzione alla presentazione dei piatti, ideale per chi cerca innovazione in un ambiente elegante.",
      en: "Creative cuisine with great attention to dish presentation — ideal for those seeking innovation in an elegant setting.",
      fr: "Cuisine créative très soignée dans la présentation, idéale pour qui cherche innovation et élégance.",
    },
  },
  {
    id: "terrazza-barchetta",
    name: "Ristorante Terrazza Barchetta",
    icon: "🌿",
    closed: { it: "Martedì", en: "Tuesday", fr: "Mardi" },
    desc: {
      it: "Sulla famosa Salita Mella, piatti di pesce e pizza al forno a legna, con uno degli spazi all'aperto più fotografati di Instagram. Perfetto per una cena informale ma raffinata nel cuore del borgo.",
      en: "On Salita Mella, fish dishes and wood-fired pizza with one of the most Instagrammed outdoor areas. Perfect for an informal yet refined dinner in the heart of the old village.",
      fr: "Sur la Salita Mella, plats de poisson et pizza au feu de bois, l'une des terrasses les plus photographiées d'Instagram.",
    },
  },
];

export const PIZZERIAS = [
  {
    name: "La Coppola",
    desc: {
      it: "Pizzeria e panetteria in Via Valassina, con pizze tradizionali e proposte creative in un ambiente accogliente.",
      en: "Pizzeria and bakery on Via Valassina — traditional and creative pizzas in a welcoming environment.",
      fr: "Pizzeria et boulangerie Via Valassina, pizzas traditionnelles et créatives.",
    },
  },
  {
    name: "Nando",
    desc: {
      it: "Sulla Salita Mella, pizze a impasto a mano con ingredienti freschi, in un ambiente casual ma curato.",
      en: "On Salita Mella, hand-made dough pizzas with fresh ingredients in a casual yet refined setting.",
      fr: "Sur la Salita Mella, pâtes à pizza faites main et ingrédients frais.",
    },
  },
  {
    name: "La Dolce Vita",
    desc: {
      it: "Nel borgo, Salita Mella, pizze classiche e piatti italiani in un'atmosfera elegante ma familiare.",
      en: "In the village on Salita Mella — classic pizzas and Italian dishes in an elegant but family-friendly atmosphere.",
      fr: "Dans le bourg, Salita Mella, pizzas classiques et plats italiens, ambiance élégante mais familiale.",
    },
  },
  {
    name: "Ristorante Bar Carillon",
    desc: {
      it: "Lungo Lario Manzoni, pizze deliziose in un ambiente accogliente, ideale per una pausa informale.",
      en: "Along Lario Manzoni — delicious pizzas in a cosy environment, ideal for an informal break.",
      fr: "Le long du Lario Manzoni, pizzas savoureuses dans un cadre chaleureux.",
    },
  },
];

export const RESTAURANTS_SECTION = {
  title: {
    it: "Guida ai migliori ristoranti di Bellagio",
    en: "Guide to the best restaurants in Bellagio",
    fr: "Guide des meilleurs restaurants de Bellagio",
  },
  intro: {
    it: "Bellagio è un gioiello incastonato sul Lago di Como, dove la cucina riflette la bellezza e la tradizione del territorio. Ecco una selezione dei ristoranti più apprezzati, ciascuno con un'esperienza unica per ogni palato.",
    en: "Bellagio is a gem on Lake Como where cuisine mirrors the beauty and tradition of the region. Here is our selection of the most highly regarded restaurants, each offering a unique experience for every palate.",
    fr: "Bellagio est un joyau sur le Lac de Côme où la cuisine reflète la beauté et la tradition du territoire. Voici notre sélection de restaurants, chacun avec une expérience unique pour chaque palais.",
  },
  pizzeriasTitle: {
    it: "Pizzerie consigliate a Bellagio",
    en: "Recommended pizzerias in Bellagio",
    fr: "Pizzerias recommandées à Bellagio",
  },
  closedLabel: { it: "Chiuso", en: "Closed", fr: "Fermé" },
  noteLabel: { it: "Nota", en: "Note", fr: "Note" },
};
